"use client";

import { c as _c } from "react/compiler-runtime";
import { getFamilyHistory, getMedicalHistory, getSocialHistory } from "@/lib/patient-health-fields";
import type { PatientChart } from "@/types/patient";
interface Props {
  patient: PatientChart;
}
function HealthHistoryList(t0) {
  const $ = _c(5);
  const {
    values
  } = t0;
  if (values.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <p className="text-caption text-muted-foreground">None recorded</p>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== values) {
    t1 = values.map(_temp);
    $[1] = values;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ul className="space-y-2">{t1}</ul>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(value, idx) {
  return <li key={idx} className="text-body text-foreground">{value}</li>;
}
export function SocialHistorySection(t0) {
  const $ = _c(4);
  const {
    patient
  } = t0;
  let t1;
  if ($[0] !== patient) {
    t1 = getSocialHistory(patient);
    $[0] = patient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <HealthHistoryList values={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export function FamilyHistorySection(t0) {
  const $ = _c(4);
  const {
    patient
  } = t0;
  let t1;
  if ($[0] !== patient) {
    t1 = getFamilyHistory(patient);
    $[0] = patient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <HealthHistoryList values={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export function MedicalHistorySection(t0) {
  const $ = _c(4);
  const {
    patient
  } = t0;
  let t1;
  if ($[0] !== patient) {
    t1 = getMedicalHistory(patient);
    $[0] = patient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <HealthHistoryList values={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}